import {
  getKnownFailureClassification,
  getKnownFailureClassificationFromText
} from './classification';
import { getNumericCode } from './utils';

export const getShortErrorName = (
  responseJson: unknown,
  reason: string,
  httpStatus?: number | string
): string => {
  const knownFailure = getKnownFailureClassification(responseJson);
  if (knownFailure) return knownFailure.errorName;

  const knownReason = getKnownFailureClassificationFromText(reason);
  if (knownReason) return knownReason.errorName;

  if (/^responseCode5\d\d$/.test(reason)) {
    return 'Service temporarily unavailable';
  }
  const numericStatus = getNumericCode(httpStatus);
  if (numericStatus && numericStatus >= 500) {
    return 'Service temporarily unavailable';
  }
  if (numericStatus === 401 || numericStatus === 403) {
    return 'Authentication required';
  }

  if (/^responseCode4\d\d$/.test(reason)) {
    return 'API request rejected';
  }

  return 'API request failed';
};
